package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.example.mystybag.appCore.logic.pages.DeliveryPageViewModel
import com.example.mystybag.core.views.AppTheme

@Composable
fun DeliveryPageWebView(viewModel: DeliveryPageViewModel) {
    val colors = AppTheme.current.colors

    Column(modifier = Modifier.background(colors.background)) {
        DeliveryPageView(viewModel = viewModel, webColumns = 2)
    }
}
